import { PageHeight, PageSize, PageWidth } from "types/v2/PageSize/PageSize";
export const calculatePageSize = (): PageSize => {
  const pageWidth: PageWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  const pageHeight: PageHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight;

  return {
    width: pageWidth,
    height: pageHeight,
  };
};
